import { render, staticRenderFns } from "./shuttlePlane.vue?vue&type=template&id=088e784c&scoped=true&"
import script from "./shuttlePlane.vue?vue&type=script&lang=js&"
export * from "./shuttlePlane.vue?vue&type=script&lang=js&"
import style0 from "./shuttlePlane.vue?vue&type=style&index=0&id=088e784c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088e784c",
  null
  
)

export default component.exports